/* * @Author: 曹俊杰 * @Date: 2024-10-24 12:24:17 * @Last Modified by: mikey.zhaopeng *
@Last Modified time: 2025-05-01 16:37:49 */咨询vip

<template>
  <div style="overflow: hidden">
    <div class="banner">
      <div class="banner-l">
        <img src="@/static/image/home/home_bg_13.webp" alt="" />
        <div class="banner-l-r">
          <div class="banner-l-r-t">
            <img src="@/assets/image/zixunVip.webp" class="text" alt="" />
            <div class="icon" v-show="VoucherNum">
              <div class="icon-l">待使用</div>
              <div class="icon-r pointer" @click="buy">
                <span> {{ VoucherNum }}张代金券</span>
                <span style="margin-left: 2px">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="4"
                    height="7"
                    viewBox="0 0 4 7"
                    fill="none"
                  >
                    <path
                      d="M0.571429 -2.49779e-08L-8.00301e-09 0.583333L2.85714 3.5L-2.54983e-08 6.41667L0.571429 7L4 3.5L0.571429 -2.49779e-08Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div class="banner-l-r-b">
            <span>{{ serviceState.value }}</span>
            <span v-if="serviceState.key == 1">
              <span style="margin: 0 4px">｜</span>
              <span>{{ user.serviceUntil | timeFormat("yyyy-mm-dd") }} 到期</span>
            </span>
          </div>
        </div>
      </div>
      <div class="banner-r" @click="buy">
        {{ serviceState.key == 0 ? "立即开通" : "续费" }}
      </div>
    </div>
    <div class="box-content defBorderRadius">
      <div class="box-content-title">购买记录</div>
      <el-table
        :data="tableData"
        style="width: 100%"
        row-class-name="defTableRowStyle"
        header-row-class-name="defTableHeaderStyle"
      >
        <el-table-column label="支付日期">
          <template slot-scope="scope">
            <span>{{ scope.row.createdAt | timeFormat("yyyy-mm-dd") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="购买套餐">
          <template slot-scope="scope">
            <span>
              <span>{{ scope.row.content }}</span>
              <!-- <span>（{{ scope.row.duration }}个月）</span> -->
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="paymentAmount" label="实际支付" width="230">
          <template slot-scope="scope">
            <div style="display: flex">
              <span style="color: #0062ff"
                >¥{{ scope.row.paymentAmount | priceFormat(2) }}</span
              >
              （
              <div
                v-if="scope.row.paymentMethod == '2'"
                style="display: flex; align-items: center; gap: 2px"
              >
                <img src="@/assets/image/voucher/zhifubao.webp" alt="" class="icon" />
                <span>支付宝支付</span>
              </div>
              <div
                v-else-if="scope.row.paymentMethod == '1'"
                style="display: flex; align-items: center; gap: 2px"
              >
                <span style="margin: 0 2px">
                  <img src="@/assets/image/voucher/yue.webp" alt="" class="icon1" />
                </span>

                <span>余额支付</span>
              </div>
              ）
            </div>
          </template>
        </el-table-column>
        <el-table-column label="代金券">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; gap: 4px">
              <img src="@/assets/image/voucher/daijinquan.webp" alt="" class="icon2" />
              <div v-if="scope.row.voucherAmount">{{ scope.row.voucherAmount }}</div>
              <div v-else>无</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开始时间">
          <template slot-scope="scope">
            <span>{{ scope.row.startAt | timeFormat("yyyy-mm-dd") }}</span>
          </template>
        </el-table-column>
        <el-table-column label="到期时间">
          <template slot-scope="scope">
            <span>{{ scope.row.endAt | timeFormat("yyyy-mm-dd") }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div
              v-html="getServiceType(scope.row.startAt, scope.row.endAt)"
            ></div>
          </template>
        </el-table-column>
        <template slot="empty">
          <empty />
        </template>
      </el-table>
      <buyAdvisory ref="buyAdvisory" @success="buySuccess" />
      <hdqPagination
        layout="prev, pager, next,sizes"
        ref="pagination"
        @change="paginationChange"
      />
    </div>
  </div>
</template>
<script>
import hdqPagination from "@/components/hdqPagination.vue";
import userinfo from "@/mixins/userinfo.js";
import buyAdvisory from "./components/buyAdvisory.vue";
import dayjs from "dayjs";
export default {
  mixins: [userinfo],
  components: {
    hdqPagination,
    buyAdvisory,
  },
  data() {
    return {
      tableData: [],
      //  现有代金券数量
      VoucherNum: 0,
    };
  },
  mounted() {
    this.getAdvisoryList();
    this.getVoucherList();
    this.pageShow();
  },
  filters: {
    payment(res) {
      if (res == "ALIPAY") {
        return "支付宝";
      } else if (res == "GIVEAWAY") {
        return "系统赠送";
      } else {
        return res;
      }
    },
  },
  methods: {
    getServiceType(startAt, endAt) {
      const now = dayjs().unix();
      const render = (text, color) =>
        `<span style="color:${color};font-size: 14px;">${text}</span>`;
      if (now < startAt) {
        return render("未开始", "#262626"); // 未开始
      } else if (now >= startAt && now <= endAt) {
        return render("服务中", "#0062FF"); // 服务中
      } else {
        return render("已到期", "#999999"); // 已到期
      }
    },
    // 页面加载
    pageShow() {
      const { query } = this.$route;
      if (query) {
        if (query.buy == 1) {
          this.buy();
        }
      }
    },
    buySuccess() {
      this.getAdvisoryList();
      this.getVoucherList();
      this.getAccount();
    },
    buy() {
      this.$refs.buyAdvisory.show();
    },
    search() {
      this.$refs.pagination.createPagination({ current: 1 });
      this.getAdvisoryList();
    },
    paginationChange() {
      this.getAdvisoryList();
    },
    async getAdvisoryList() {
      const { current, size } = this.$refs.pagination;
      const { data, status } = await this.$api.getAdvisoryList({ current, size });
      if (status == 200) {
        this.tableData = data.records;
        this.$refs.pagination.createPagination(data);
      }
    },
    async getVoucherList(params) {
      const { data, status } = await this.$api.getVoucherList({ type: 1, state: 0 });
      if (status == 200) {
        this.VoucherNum = data.records.length;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.box-content {
  padding: 0 20px 20px;
  background: #fff;

  &-title {
    color: #262626;
    font-family: "Noto Sans SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 60px;
  }
}

.banner {
  padding-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url(~@/assets/image/zixun/left.webp),
    url(~@/assets/image/zixun/right.webp),
    linear-gradient(90deg, #444963 0%, #1d1e35 100%);
  background-position: 166px, right, center;
  background-repeat: no-repeat, no-repeat, repeat;
  background-size: auto 100%, auto 100%, 100%;
  height: 90px;
  margin-bottom: 16px;
  // background-size: 100%;
  border-radius: 6px;
  &-l {
    display: flex;
    align-items: center;
    padding-left: 16px;
    img {
      width: 52px;
      margin-right: 12px;
    }

    &-r {
      &-t {
        display: flex;
        align-items: center;

        .text {
          width: 70px;
          height: 26px;
        }

        .icon {
          display: flex;
          margin-left: 6px;

          &-l {
            color: #fff;
            font-family: "Noto Sans SC";
            font-size: 10px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            display: inline-flex;
            height: 18px;
            padding: 2px 4px;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            border-radius: 4px 0px 0px 4px;
            background: linear-gradient(111deg, #f07b41 2.95%, #e8331a 100%);
            text-align: center;
          }

          &-r {
            display: flex;
            height: 18px;
            padding: 2px 4px;
            justify-content: center;
            align-items: center;
            gap: 2px;
            flex-shrink: 0;
            border-radius: 0px 4px 4px 0px;
            background: linear-gradient(90deg, #974d1c 0%, #311909 100%);
            color: #fff;
            font-family: "Noto Sans SC";
            font-size: 10px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px;
            text-align: center;
          }
        }
      }

      &-b {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #ffffff;

        z-index: 0;
        margin-top: 4px;
      }
    }
  }

  &-r {
    width: 80px;
    height: 34px;
    flex-shrink: 0;
    border-radius: 100px;
    background: linear-gradient(90deg, #feeacd 0%, #fbd29d 100%);
    color: #272a41;
    font-family: "Noto Sans SC";
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0em;
    font-weight: 500;
    line-height: 34px;
    text-align: center;
    cursor: pointer;
  }
}
.none {
  background-image: url(~@/static/image/home/home_bg_9.png);
}
.icon1 {
  width: 14px;
  height: 14px;
}
.icon2 {
  width: 16px;
  height: 16px;
}
</style>
